'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'swatchbook';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f5c3';
var svgPathData = 'M0 416c0 53 43 96 96 96l416 0 0-192-112.4 0-32 32 112.4 0 0 128-308.3 0 275.5-275.5 11.3-11.3-11.3-11.3-113.1-113.1-11.3-11.3-11.3 11.3-71.5 71.5 0 45.3 82.8-82.8 90.5 90.5-221.4 221.4 0-414.5-192 0 0 416zm96 64c-35.3 0-64-28.7-64-64l0-128 128 0 0 128c0 35.3-28.7 64-64 64zM32 256l0-96 128 0 0 96-128 0zm0-128l0-96 128 0 0 96-128 0zM96 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSwatchbook = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;